import React, { useContext, useEffect } from 'react'
import QRCode from "react-qr-code"
import { useQuery } from '@tanstack/react-query'
import { FiPrinter } from 'react-icons/fi'
import { useParams } from 'react-router-dom'

import logo from '../../../../../assets/images/positronic horizontal.png'
import { GlobalContext } from '../../../../../contexts/GlobalContext'
import Spinner from '../../../../../components/Spinner'
import { api, authHeaders } from '../../../../../services/api'
import useQueryHook from '../../../../../hooks/useQuery'
import cruzVermelha from '../../../../../assets/images/cruz vermelha.png'
import neuroatipico1 from '../../../../../assets/images/tags/neuroatipico1.png'
import neuroatipico2 from '../../../../../assets/images/tags/neuroatipico2.png'
import neuroatipico3 from '../../../../../assets/images/tags/neuroatipico3.png'
import neuroatipico4 from '../../../../../assets/images/tags/neuroatipico4.png'
import neuroatipico5 from '../../../../../assets/images/tags/neuroatipico5.png'

export default function () {
	const { user } = useContext(GlobalContext)

	const { formato } = useQueryHook()

	const { pessoa_id } = useParams()

	const { data: pessoa } = useQuery({
		queryKey: ['obter-pessoa-prontuario-tag'],
		queryFn: async () => {
			const response = await api.get(`pessoa/${pessoa_id}`, authHeaders())

			return response
		}
	})

	const { data: tokenData } = useQuery({
		queryKey: ['get-tag-token-emergency'],
		queryFn: async () => {
			const response = await api.get(`prontuario/emergencia/get_token/${pessoa_id}`, authHeaders())

			return response
		}
	})

	useEffect(() => {
		setTimeout(() => {
			window.print()
		}, 2000)
	}, [])

	if ((!user && !pessoa) || !tokenData) {
		return (
			<Spinner />
		)
	}

	const token = tokenData.token
	const urlQRCode = `${process.env.REACT_APP_FRONTEND_URL}/emergencia/${token}`

	let Component

	switch (formato) {
		case 'chaveiro':
			Component = Chaveiro
			break

		case 'broche':
			Component = Broche
			break

		case 'adesivo':
			Component = Adesivo
			break

		case 'neuroatipico1':
			Component = Neuroatipico1
			break

		case 'neuroatipico2':
			Component = Neuroatipico2
			break

		case 'neuroatipico3':
			Component = Neuroatipico3
			break

		case 'neuroatipico4':
			Component = Neuroatipico4
			break

		case 'neuroatipico5':
			Component = Neuroatipico5
			break

		default:
			Component = Cartao
			break
	}

	return (
		<div className="bg-white h-screen flex flex-col gap-8">
			<Component pessoa={pessoa || user.pessoa} urlQRCode={urlQRCode} />

			<button onClick={() => { window.print() }} className="flex gap-1.5 bg-emerald-600 text-white p-3 rounded-md hover:opacity-80 w-fit ml-10 print:hidden">
				<FiPrinter size={18} />
				Imprimir
			</button>
		</div>
	)
}

function Cartao({ urlQRCode, pessoa }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10 print:m-0">
			<div className="flex" style={{ gap: 0 }}>
				<div className="flex flex-col items-center gap-2 border rounded-md border-dashed border-gray-500 p-4 w-[8.56cm] h-[5.39cm] text-slate-800">
					<p className="text-xs print:text-slate-800">Em caso de emergência, leia este QRCode.</p>

					<QRCode value={urlQRCode} className="w-[2.8cm] h-[2.8cm]" />

					<p className="text-center text-xs print:text-slate-800">Abra a câmera do seu celular e aponte para o QRCode ou baixe algum aplicativo para leitura de QRCodes.</p>
				</div>

				<div className="flex flex-col justify-between items-center gap-2 border rounded-md border-dashed border-gray-500 p-4 w-[85.6mm] h-[53.98mm] text-slate-800">
					<div />

					<div className="flex gap-2 items-center">
						<img src={cruzVermelha} alt="" className="w-[2cm]" />

						<h1 className="text-lg font-bold text-slate-800">CARTÃO DE EMERGÊNCIA MÉDICA</h1>
					</div>

					<h2 className="text-lg font-bold text-center text-slate-800">{pessoa.nome}</h2>

					<img src={logo} className="h-[0.8cm] object-contain" />
				</div>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>As dimensões de cada lado da imagem acima são: 8,56cm x 5,39cm</span>
		</div>
	)
}

function Chaveiro({ urlQRCode, pessoa }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="flex">
				<div className="w-[5cm] h-[5cm] object-cover border border-dashed border-gray-500 flex justify-center items-center">
					<QRCode value={urlQRCode} className="w-[4.4cm] h-[4.4cm]" />
				</div>

				<div className="w-[5cm] h-[5cm] border border-dashed border-gray-500 p-4 flex flex-col gap-1.5 justify-center items-center">
					<h1 className="font-bold text-slate-800 text-center" style={{ fontSize: 13 }}>{pessoa.nome}</h1>

					<img src={cruzVermelha} alt="" className="h-[2.5cm] object-contain" />

					<h1 className="text-slate-800 text-center" style={{ fontSize: 12 }}>Em caso de emergência, leia o QRCode no verso.</h1>
				</div>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>As dimensões de cada lado da imagem acima são: 4,4cm x 4,4cm</span>
		</div>
	)
}

function Broche({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[3.4cm] h-[3.4cm] object-cover rounded-full border border-dashed border-gray-500 flex flex-col justify-center items-center bg-red-600">
				<QRCode value={urlQRCode} className="w-[2.1cm] h-[2.1cm] mt-2" />

				<span className="text-white font-semibold" style={{ fontSize: 11 }}>Emergências</span>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>O diâmetro da imagem acima é: 3,5cm</span>
		</div>
	)
}

function Adesivo({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[6cm] h-[6cm] object-cover rounded-full border border-dashed border-gray-500 flex gap-1 flex-col justify-center items-center">
				<div className='rotate-180 flex flex-col items-center'>
					<span className="font-semibold text-red-500" style={{ fontSize: 13 }}>EMERGÊNCIA</span>
					<span className="font-semibold text-red-500" style={{ fontSize: 13 }}>MÉDICA</span>
				</div>

				<QRCode value={urlQRCode} className="w-[4cm] h-[4cm]" />
				<div className='flex flex-col items-center'>
					<span className="font-semibold text-red-500" style={{ fontSize: 13 }}>EMERGÊNCIA</span>
					<span className="font-semibold text-red-500" style={{ fontSize: 13 }}>MÉDICA</span>
				</div>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>O diâmetro da imagem acima é: 6cm</span>
		</div>
	)
}

function Neuroatipico1({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[6cm] h-[6cm] object-cover flex gap-2 flex-col justify-center items-center relative">
				<img src={neuroatipico1} className="w-[9cm] h-[9cm]" />
				<QRCode value={urlQRCode} className="w-[2.4cm] h-[2.4cm] absolute top-14" />
				<p className="text-center text-red-600 font-bold">EMERGÊNCIAS</p>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>A altura da imagem acima é, aproxidamente, 9cm</span>
		</div>
	)
}

function Neuroatipico2({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[6cm] h-[6cm] object-cover flex gap-2 flex-col justify-center items-center relative">
				<img src={neuroatipico2} className="w-[9cm] h-[9cm]" />
				<QRCode value={urlQRCode} className="w-[4cm] h-[4cm] absolute top-18 left-4" />
				<p className="text-red-600 font-bold ml-11 -mt-6 self-start">EMERGÊNCIAS</p>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>A altura da imagem acima é, aproxidamente, 9cm</span>
		</div>
	)
}

function Neuroatipico3({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[6cm] h-[6cm] object-cover flex gap-2 flex-col justify-center items-center relative">
				<img src={neuroatipico3} className="w-[9cm] h-[9cm]" />
				<QRCode value={urlQRCode} className="w-[4cm] h-[4cm] absolute top-[3.2rem] left-3" />
				<p className="text-red-600 font-bold ml-9 -mt-1 self-start">EMERGÊNCIAS</p>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>A altura da imagem acima é, aproxidamente, 9cm</span>
		</div>
	)
}

function Neuroatipico4({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[6cm] h-[6cm] object-cover flex gap-2 flex-col justify-center items-center relative">
				<img src={neuroatipico4} className="w-[9cm] h-[9cm]" />
				<QRCode value={urlQRCode} className="w-[3.6cm] h-[3.6cm] absolute top-8 left-[2.8rem]" />
				<p className="text-red-600 font-bold -mt-1">EMERGÊNCIAS</p>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>A altura da imagem acima é, aproxidamente, 9cm</span>
		</div>
	)
}

function Neuroatipico5({ urlQRCode }) {
	return (
		<div className="flex flex-col gap-6 ml-10 mt-10">
			<div className="w-[6cm] h-[6cm] object-cover flex gap-2 flex-col justify-center items-center relative">
				<img src={neuroatipico5} className="w-[9cm] h-[9cm]" />
				<QRCode value={urlQRCode} className="w-[3.2cm] h-[3.2cm] absolute top-[2.4rem] left-[3.3rem]" />
				<p className="text-red-600 font-bold">EMERGÊNCIAS</p>
			</div>

			<span className="text-slate-600 print:hidden" style={{ fontSize: 12 }}>A altura da imagem acima é, aproxidamente, 9cm</span>
		</div>
	)
}